
import { i18n } from '@/main';
import {headerWithTooptipRenderer} from '@/pro/utils/grid/rendererUtils';
import {OptColumn} from '@/pro/types';
import {formatCurrency} from '@/pro/utils/numberFormat';
import {getAnchorHTML} from '@/pro/utils/grid/formatterUtils';
import {Row} from '@/pro/types/tui-grid';
import {throwPopup} from '@/pro/helpers/popup';

export const getSupplyPriceHeader = () => ({
  name: 'supplyPrice',
  renderer: props => {
    props.tooltipId = 'supplyPrice';
    return headerWithTooptipRenderer(props);
  },
});

interface CommissionType {
  rate: number;
  type: string;
}

export const getSupplyPriceColumn = (minWidth = 100): OptColumn => ({
  header: 'PRO_PRODUCT_SUPPLY_PRICE',
  name: 'supplyPrice',
  align: 'center',
  minWidth,
  formatter: ({ row, value }) => {
    const { hasOption, saleMethodType, commission } = row;
    const { type } = commission as CommissionType;
    const isSupplyPriceByOption = hasOption === true && saleMethodType === 'CONSIGNMENT' && type === 'PURCHASE_PRICE';
    const formattedValue = formatCurrency(value as number);
    return isSupplyPriceByOption ? getAnchorHTML(i18n.t('DETAILS')) : formattedValue;
  },
});

export const openSupplyPriceDetailsPopup = (rowData: Row) => {
  const { commission } = rowData;

  if (commission && commission['type'] !== 'PURCHASE_PRICE') {
    return;
  } else {
    throwPopup({
      name: 'SupplyPriceDetails',
      data: { mallProductNo: rowData.mallProductNo },
    });
  }
};
